import { render, staticRenderFns } from "./iam-new-page.vue?vue&type=template&id=523b3599&"
import script from "./iam-new-page.vue?vue&type=script&lang=js&"
export * from "./iam-new-page.vue?vue&type=script&lang=js&"
import style0 from "./iam-new-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./iam-new-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QSelect,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QSelect,QBtn,QSpinnerIos,QField})
